var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8445_20318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02114 16.7503L8.29578 12.7794L9.7937 14.69L6.90654 18.3616C5.80082 19.7666 3.75476 18.286 5.02114 16.7503ZM8.84549 7.70762C9.15736 6.69011 9.01402 5.82065 7.84215 4.52907L4.97862 1.08432C4.57224 0.607066 3.61458 1.30799 4.01465 1.88605L6.30485 4.70705C6.738 5.23314 5.93313 5.92933 5.4858 5.3875L3.11685 2.47041C2.67582 1.9648 1.76383 2.63265 2.22534 3.21071C2.89318 4.01401 3.92645 5.32607 4.59429 6.12937C5.05737 6.60032 4.3533 7.29809 3.89652 6.71058L1.5449 3.8124C1.19995 3.43752 0.636062 3.67064 0.486428 4.10852C0.325767 4.57632 0.721118 4.91812 0.99046 5.26464L3.61458 8.65426C4.42891 9.59774 5.33931 10.1569 6.39778 9.84031C6.56002 9.79148 6.75848 9.69225 6.97112 9.56151L14.0213 18.6624C14.4009 19.1523 15.1333 19.2043 15.609 18.8089L15.7177 18.7192C16.2532 18.2734 16.3398 17.4591 15.8815 16.933L8.41548 8.35499C8.63285 8.11242 8.79193 7.88246 8.84549 7.70762ZM10.8411 9.69225L12.002 8.28411C10.5088 4.58262 16.0421 -0.350595 18.7245 1.91755C21.9834 4.67555 17.14 11.3225 13.7362 9.67965L12.3611 11.4264L10.8411 9.69225Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8445_20318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3548,
    height: 19.3548,
    fill: "white",
    transform: "translate(0.451172 0.322632)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodRestaurant);
export default __webpack_public_path__ + "static/media/foodRestaurant.1b9386517cea3ab467627c63542a476b.svg";
export { ForwardRef as ReactComponent };